<template>
  <div>
    <comHeaderAnyone :propScreenTitle="screenTitle"></comHeaderAnyone>
    <v-main>
      <v-container class="container-9">
        <v-card :loading="loading" class="mx-auto mt-0 my-sm-12" :max-width="inputLoginWidth">
          <template slot="progress">
            <v-progress-linear
              color="deep-purple"
              height="10"
              indeterminate
            ></v-progress-linear>
          </template>

          <div class="rogo" @click="home()">
            <v-img height="220px" src="@/assets/img/background.jpg"></v-img>
            <p>登&nbsp;記&nbsp;<span class="logo_rotate">託</span></p>
            <v-img class="tqsman" src="@/assets/img/tqsman-big.png"></v-img>
          </div>

          <v-card-title></v-card-title>

          <v-card-text>
            <v-row align="center" class="mx-0">
              <v-text-field
                label="メールアドレス"
                single-line
                solo
                v-model="roginId"
              ></v-text-field>
            </v-row>
            <v-row align="center" class="mx-0">
              <v-text-field
                solo
                v-model="password"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show1 ? 'text' : 'password'"
                name="input-10-1"
                label="パスワード"
                @click:append="show1 = !show1"
              ></v-text-field>
            </v-row>
            <v-card class="d-flex justify-center mb-0" flat>
              <v-checkbox
                v-model="chkboxSP"
                label="ログイン情報を保存する"
              ></v-checkbox>
            </v-card>
            <v-card class="d-flex justify-center mb-6" flat>
              <v-card-actions>
                <v-btn
                  x-large
                  color="warning"
                  dark
                  min-width="200px"
                  @click="login()"
                  >{{ $t("LMB001") }}</v-btn
                >
              </v-card-actions>
            </v-card>
            <v-row class="mt-1" style="height: 2vh;"></v-row>
            <v-card class="d-flex justify-center mb-6" flat>
              <router-link :to="{name:'MBA200'}">パスワードをお忘れですか？</router-link>
            </v-card>
           
            <v-divider class="mx-4"></v-divider>
            <v-row class="mt-1" style="height: 2vh;"></v-row>
            <v-card class="d-flex justify-center mb-6 text-caption text-sm-subtitle-2" flat>
              <span class="mt-2">アカウントをお持ちでない場合、</span>
              <v-btn plain @click="regsterNew()" class="pa-0" color="blue darken-4">
                登録はこちらから
              </v-btn>
              <!-- <router-link  @click="regsterNew()">登録はこちらから</router-link> -->
            </v-card>
            <v-card class="d-flex justify-center mb-6" flat>
              <router-link :to="{name:'PSS100'}">ホームページへ戻る</router-link>
            </v-card>
          </v-card-text>
        </v-card>
        <!-- その他 -->
        <comMessage :msg="dlgMsg.msg" :is-open="dlgMsg.isOpen" :do-yes="dlgMsg.doYes"></comMessage>
      </v-container>
    </v-main>
    <!-- フッター -->
    <!-- 利用規約 プライバシーポリシー 特定商取引法に基づく表記 -->
    <!-- <comFooterAnyone :contactUsDspFlg="contactUsDspFlg" :moveTopDspPos="moveTopButtonPos" :propSrcScreenId="screenId"></comFooterAnyone> -->
  </div>
</template>

<script>
import Constants from "../common/constants";
import Utils from "../common/utils";
export default {
  name: "Login",
  data() {
    return {
      screenTitle: "",
      screenId: "MBA100",
      loading: false,
      roginId: "",
      show1: false,
      password: "",
      contactUsDspFlg: false,
      moveTopButtonPos: "",
      chkboxSP: false,
      dlgMsg: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsg.isOpen = false;
        },
      },
    };
  },
  computed: {
    inputLoginWidth() {
      let bp =this.$vuetify.breakpoint.name;
      if (bp == 'xs' ) {
        return "100%";
      } else if (bp == 'md' || bp == 'sm') {
        return "80%";
      } else if (bp == 'lg' || bp == 'xl') {
        return "50%";
      } else {
        return "50%";
      }
    }
  },
  created() {
    this.initialize();
  },
  methods: {
   /*
    * 初期表示
    */
    initialize: function() {
      let hasCookie = this.getCookieArray();
      if (hasCookie) {
        this.chkboxSP = true;
      }
      let loginIdAfterRegistAccount = this.$store.getters["authcUser/getLoginIdAfterRegistAccount"];
      if (loginIdAfterRegistAccount != null && loginIdAfterRegistAccount != "") {
        this.roginId = loginIdAfterRegistAccount;
      }
      this.$store.commit("authcUser/resetState");
    },
    home: function() {
      this.$router.push( this.$router.resolve({ name: 'PSS100' }).href);
    },
    /**
     * アカウント登録画面遷移
     */
    regsterNew: function() {
      // // 別タブ表示
      // let routeData = this.$router.resolve({name: "MBC100"});
      // window.open(routeData.href, "_blank", 'noreferrer');
      this.$router.push(this.$router.resolve({ name: "MBC100" }).href);
    },
    /*
     * ログインボタン押下
     */
    login: async function() {
      this.loading = true;
      // 単項目チェック
      let chkRslt = this.checkForLogin();
      if (!chkRslt) {
        this.loading = false;
        return;
      }
      let errStatus = null;
      // ログインサービス呼び出し
      let apiurl = Constants.URL_API_MBA100G01;
      try {
        let data = JSON.stringify({username: this.roginId, password: this.password});
        let response = await this.$axios.post(apiurl, data,
            {
              headers: {"content-type": "application/json"}, 
              responseType: "json"
            }
            );
        let accessToken = response.headers['x-auth-token'];
        this.$store.dispatch("authcUser/setAccessToken", accessToken);
        if (this.chkboxSP) {
          let expire = new Date();
          expire.setTime( expire.getTime() +  30 * 1000 * 3600 * 24 );
          let expireStringVal = "; expires=" + expire.toUTCString();
          
          document.cookie = "comregroginId=" + this.roginId + expireStringVal;
          document.cookie = "comregpassword=" + this.password + expireStringVal;
        }
        this.$router.push(this.$router.resolve({ name: "MBR100" }).href);
      } catch(error) {
        errStatus = error.response.status;
      } finally {
        this.loading = false;
      }

      if (errStatus != null) { 
        if (errStatus >= 400 && errStatus < 500) {
          this.dlgMsg.msg = this.$i18n.t('msg.err.mb070');
          this.dlgMsg.isOpen = true;
        } else {
          this.dlgMsg.msg = this.$i18n.t('msg.err.cm500');
          this.dlgMsg.isOpen = true;
        }
      }
    },
    
    checkForLogin: function() {
      let retVal = false;
      if (!this.unitCheckForLogin()) {
        return retVal;
      }
      retVal = true;
      return retVal;
    },

    unitCheckForLogin: function() {
      let retVal = true;
      let errList = new Array();
      this.$i18n
      if (this.roginId == "") {
        errList.push(this.$i18n.t('msg.err.cm020', ['メールアドレス']));
      }
      if (this.password == "") {
        errList.push(this.$i18n.t('msg.err.cm020', ['パスワード']));
      }
      if (errList.length > 0) {
        retVal = false;
        this.dlgMsg.msg = Utils.createMsgViewString(errList);
        this.dlgMsg.isOpen = true;
      }
      return retVal;
    },

    getCookieArray: function() {
      let hasCookies = false; 
      let arr = new Array()
      if (document.cookie != '') {
        let tmp = document.cookie.split('; ');
        for (let i = 0; i < tmp.length; i++) {
            let data = tmp[i].split('=');
            arr[data[0]] = decodeURIComponent(data[1])
        }
        if (arr['comregroginId'] !== '' && arr['comregpassword'] !== '') {
            hasCookies = true
            this.roginId = arr['comregroginId'];
            this.password = arr['comregpassword'];
        }
      }
      return hasCookies;
    },

  },
};
</script>
<style scoped>
.bg-image {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-size: cover;
  background-image: url("../assets/img/background.jpg");
  background-color: rgba(255, 255, 255, 0.8);
  background-blend-mode: lighten;
}

.rogo {
  position: relative;
  font-family: "HGP行書体", "Roboto", "ＭＳ Ｐ明朝", "MS PMincho", "STKaiti",
    "ヒラギノ明朝 Pro W3", "Hiragino Mincho Pro", serif !important;
  font-weight: bold;
  font-size: 1.8em;
}

.rogo P {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  margin: 0;
  padding: 0;
  font-size: 1.8em;
}
.logo_rotate {
  display: inline-block;
  transform: rotate(-12deg);
  font-size: 1.4em;
  margin: 0px 5px;
}
.tqsman {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: absolute;
  top: 50%;
  left: 60%;
}
@media screen and (max-width: 960px) {
  .rogo {
    font-size: 1.5em;
  }
  .rogo P {
    font-size: 1.5em;
  }
  .tqsman {
    top: 60%;
    left: 44%;
  }
}
</style>
